// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayerModal_container__g+4Wc","closePlayer":"VideoPlayerModal_closePlayer__EpAVd"};